// Hook genérico para operações de senha (reset e convite)
import { useRequest } from './useRequest';
import { useCallback } from 'react';

export type PasswordOperationType = 'reset' | 'invitation';

export interface PasswordOperationParams {
  type: PasswordOperationType;
  email: string;
  token: string;
}

export function usePasswordOperation() {
  const requestPasswordResetRequest = useRequest<void>();
  const validateTokenRequest = useRequest<any>(undefined);
  const passwordOperationRequest = useRequest<void>();

  // Solicitar recuperação de senha
  const requestPasswordReset = useCallback(async (email: string) => {
    await requestPasswordResetRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/autenticador/recuperarsenha`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
  }, [requestPasswordResetRequest]);

  // Validar token (usado para reset de senha)
  const validateToken = useCallback(async (email: string, token: string) => {
    await validateTokenRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/autenticador/validartoken`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, token }),
    });
  }, [validateTokenRequest]);

  // Executar operação de senha (reset ou convite - mesma API)
  const executePasswordOperation = useCallback(async (
    password: string,
    confirmPassword: string,
    email: string,
    token: string,
    type: PasswordOperationType
  ) => {
    const endpoint = type === 'reset'
      ? '/api/autenticador/resetarsenha'
      : '/api/autenticador/resetarsenha';

    await passwordOperationRequest.execute(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password, confirmPassword, email, token }),
    });
  }, [passwordOperationRequest]);

  return {
    // Estados para solicitação de recuperação
    requestLoading: requestPasswordResetRequest.loading,
    requestError: requestPasswordResetRequest.error,

    // Estados de validação (usado apenas para reset)
    validateLoading: validateTokenRequest.loading,
    validateError: validateTokenRequest.error,
    validateData: validateTokenRequest.data,

    // Estados de operação
    operationLoading: passwordOperationRequest.loading,
    operationError: passwordOperationRequest.error,

    // Funções
    requestPasswordReset,
    validateToken,
    executePasswordOperation,
  };
}